import React, { useEffect } from 'react';

import { bemCssModules } from '@utils';
import { useNavigate } from '@utils/hooks';

import { useStore, walletActions, cardsActions } from '@modules';

import WalletsOverview from '@components/WalletsOverview';
import Cards from '@containers/Cards';
// import UserLimits from '@containers/UserLimits';
import LoaderLayout from '@layouts/LoaderLayout';
import WalletLayout from '@layouts/WalletLayout';

import Info from './Info';
import UserName from './UserName';
import UserStatus from './UserStatus';
import ArrowIcon from './arrow.svg';

import style from './Profile.scss';

const cn = bemCssModules(style, 'Profile');

const Profile: CustomFC = ({ className }) => {
  const navigate = useNavigate();
  const [{ user, wallet }, dispatch] = useStore();
  const userData = user.data;
  const walletData = wallet.data;

  useEffect(() => {
    dispatch(cardsActions.getCards());
    dispatch(walletActions.getWallet());
  }, []);

  const handleClickProfile = () => navigate(CONST.nav.profileEdit);

  const isLoading =
    (user.loaders.getUserData && !userData) || (wallet.loaders.getWallet && !walletData);

  const header = (
    <button type="button" className={cn('button')} onClick={handleClickProfile}>
      <UserName firstName={userData?.first_name} firstNameEn={userData?.first_name_en} />
      <UserStatus />
      <ArrowIcon className={cn('arrow')} />
    </button>
  );

  return (
    <WalletLayout header={header}>
      <div className={cn(null, [className])}>
        <LoaderLayout isLoading={isLoading}>
          <WalletsOverview className={cn('wallet-overview')} />
          {/* <UserLimits className={cn('limits')} /> */}
          <Cards className={cn('mobile-cards')} />
          <Info className={cn('info')} />
        </LoaderLayout>
      </div>
    </WalletLayout>
  );
};

export default Profile;
